import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./i18n";
import App from "./App";
import "./index.css";

Sentry.init({
  dsn: "https://f209ec333c29bcd99746a75190279a64@o1252852.ingest.us.sentry.io/4511399666515968",
  sendDefaultPii: true,
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
